import useSWR from "swr"
import useHandleChange from "../../hooks/useHandleChange"
import { fetchApiAuthorized } from "../../network/fetch"
import { useAuthStore } from "../../state/stores/authStore"
import ScheduleItemView, { ScheduleItemSubviewProps } from "./scheduleItemView"

export const ScheduleItemQuizView = ({
	value,
	onChange,
}: ScheduleItemSubviewProps) => {
	const [_value, setValue] = useHandleChange(value ?? "default", onChange)

	const token = useAuthStore((state) => state.adminToken)
	const expiresIn = useAuthStore((state) => state.adminExpiresIn)
	const { data: quizzes } = useSWR(
		["/quizzes", token, expiresIn],
		fetchApiAuthorized
	)

	return (
		<ScheduleItemView
			data={quizzes}
			header="Quiz"
			title="question"
			value={_value}
			onChange={setValue}
		/>
	)
}

export default ScheduleItemQuizView
